/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-20 14:58:06
 * @LastEditTime: 2019-08-22 14:44:02
 * @LastEditors: Please set LastEditors
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import elementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
// 分页组件
import Pagination from "@/components/Pagination";
// import '@/assets/css/element-variables.scss'

Vue.config.productionTip = false
Vue.use(elementUI)
// axios.defaults.baseURL = 'http://127.0.0.1:10011/';
axios.defaults.baseURL = 'https://longjian.ranken.com.cn/prod-api';
// axios.defaults.baseURL = 'https://www.ranken.com.cn/prod-api';
Vue.component('Pagination', Pagination);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js